export function dumpTriggerMessage(reason, error) {
  const params = {reason}
  if (error) {
    params.error = error
  }
  return {
    method: 'log:dumpTrigger',
    params,
  }
}
export function dumpLogDataMessage(logs, reason, error, liteSessionId, callId) {
  const params = {logs}
  if (reason) {
    params.reason = reason
  }
  if (error !== undefined) {
    params.error = error
  }
  if (liteSessionId) {
    params.liteSessionId = liteSessionId
  }
  if (callId) {
    params.callId = callId
  }
  return {
    method: 'log:dumpData',
    params,
  }
}
